enum ThermicTypo {
    Aucun,
    Chauffe,
    NonChauffe,
    Exterieur
}

export default ThermicTypo;